import React from 'react';
import PropTypes from 'prop-types';
//import _get from 'lodash.get';
import AdCaller from 'helpers/ads/adCaller';

const sidebarAdHeight = 250;
class RenderAds extends React.Component {
  getAdData = adObject => {
    if (!adObject) return {};
    return {
      targetingInfo: adObject.info,
      ...adObject,
      divId: adObject.divId || adObject.slotId,
    };
  };

  renderDFPAd = ({ adObject, immediateLoad = false }) => {
    const theme = `${this.props.colorTheme}`;
    const adClass = `${this.props.adWrapperClass}`;
    const _immediateLoad =
      immediateLoad !== false ? immediateLoad : this.props.immediateLoad;
    const { wrapperClass } = this.props;
    // const { minHeight } = adObject?.wrapperStyle || {};
    let styleObj = {};
    if (adObject?.wrapperStyle) {
      styleObj = adObject?.wrapperStyle;
    }
    if (wrapperClass || Object.keys(styleObj).length > 0) {
      return (
        <div style={styleObj} className={wrapperClass}>
          <AdCaller
            data={this.getAdData(adObject)}
            immediateLoad={_immediateLoad}
            className={`${adClass} ${theme}`}
            deviceType={this.props.isWapView ? 'mobile' : undefined}
          />
        </div>
      );
    }
    return (
      <AdCaller
        data={this.getAdData(adObject)}
        immediateLoad={_immediateLoad}
        className={`${adClass} ${theme}`}
        deviceType={this.props.isWapView ? 'mobile' : undefined}
      />
    );
  };

  getAd = adObject => {
    const adClass = `${this.props.adWrapperClass}`;
    if (adObject.adType === 'dfp') {
      return this.renderDFPAd({ adObject });
    } else if (adObject.adType === 'ctn') {
      return (
        <AdCaller
          data={{
            adCode: adObject.adCode || adObject.slotId,
            msid: adObject.msid,
            divId: adObject.divId,
          }}
          className={adClass}
          isCTN
        />
      );
    } else if (adObject.adType !== '') {
      return <AdCaller data={adObject} className={adClass} />;
    }
    return null;
  };

  adConditionCheck = adObject => {
    const checkType = adObject?.condition?.type || '';
    if (checkType) {
      switch (checkType) {
        case 'daycheck': {
          const days = adObject?.condition?.days || '';
          if (days) {
            const today = new Date();
            const dayName = today.toLocaleDateString(undefined, {
              weekday: 'short',
            });
            return days.includes(dayName);
          }
          return false;
        }
        case 'checkAdConfig': {
          return this.props.campaigns?.inline_custom_mid_ad?.isAdActive === 1;
        }
        default: {
          return false;
        }
      }
    }
    return true;
  };

  render() {
    const { adWrapperClassname } = this.props;
    let { adObject = {}, noPlaceholder } = this.props;
    const isSidebarAd =
      typeof adObject === 'object' &&
      adObject.size &&
      adObject.size instanceof Array &&
      adObject.size.length >= 2 &&
      adObject.size[1] === sidebarAdHeight;

    const { adType, wrapperjClass } = adObject;
    if (adType === 'taboola') {
      noPlaceholder = true;
    }
    const validateAd = this.adConditionCheck(adObject);
    if (!validateAd) {
      if (adObject?.condition?.fallback) {
        adObject = adObject?.condition?.fallback;
      } else {
        adObject = null;
        return null;
      }
    }
    const overrideDefaultClass =
      wrapperjClass ||
      `paisa-wrapper ${this.props.addMarginTop ? 'margin-top' : ''}`;

    const ad = !noPlaceholder ? (
      <div className={overrideDefaultClass}>{this.getAd(adObject)}</div>
    ) : (
      this.getAd(adObject)
    );
    const adWrapperDiv = <div className={adWrapperClassname}>{ad}</div>;
    if (isSidebarAd && adWrapperClassname) {
      return <div className="main-paisa">{adWrapperDiv}</div>;
    } else if (isSidebarAd) {
      return <div className="main-paisa">{ad}</div>;
    } else if (adWrapperClassname) {
      return adWrapperDiv;
    }

    return ad;
  }
}

RenderAds.propTypes = {
  adObject: PropTypes.shape({}).isRequired,
  adWrapperClassname: PropTypes.string,
  adWrapperClass: PropTypes.string,
  noPlaceholder: PropTypes.bool,
  addMarginTop: PropTypes.bool,
  isWapView: PropTypes.bool,
  colorTheme: PropTypes.string,
  wrapperClass: PropTypes.string,
  campaigns: PropTypes.shape({}),
};

RenderAds.defaultProps = {
  adWrapperClassname: undefined,
  adWrapperClass: '',
  colorTheme: '',
  noPlaceholder: false,
  addMarginTop: false,
  isWapView: false,
  wrapperClass: '',
  campaigns: {},
};

export default RenderAds;
